import { productImages } from "../assets/product/product";

export const productContentConfig = [
    {
        pageName: "medrixo",
        title: "Medrixo",
        backgroundImage: productImages.medrixo.hero,
        infoSection: {
            image: productImages.medrixo.mockup,
            alt: "medrixoMockupImg",
            paragraphs: [
                <div className="col-12">
                    <p className="text-primary">
                        Medrixo serves as your premier destination for seamless access to
                        essential medications. Our dedicated team is committed to
                        facilitating the delivery of prescribed medicines directly to your
                        doorstep.
                    </p>
                    <p className="text-primary">
                        Through our user-friendly online platform, you can conveniently
                        purchase prescribed medications and healthcare products at
                        discounted rates.
                    </p>
                    <p className="text-primary">
                        Recognizing the significance of timely medication, we've streamlined
                        the ordering process to ensure utmost convenience from the comfort
                        of your home.
                    </p>

                    <p className="text-primary">
                        Our website boasts an intuitive interface, safeguarding your
                        information with robust security measures. At Medrixo, your
                        satisfaction is our top priority. We prioritize confidentiality and
                        reliability throughout our service, ensuring discreet packaging and
                        secure transactions.
                    </p>

                    <p className="text-primary">
                        Whether you require regular medication or occasional prescriptions,
                        Medrixo stands ready to meet your needs. We advocate for
                        accessibility and affordability in healthcare, ensuring that
                        everyone can access necessary medications without difficulty.
                    </p>
                    <p className="text-primary">
                        Join us in our commitment to enhancing the healthcare experience.
                        Opt for Medrixo for unparalleled convenience, reliability, and
                        cost-effectiveness in fulfilling your medical requirements.
                    </p>
                </div>,
            ],
        },
    },
    {
        pageName: "taxongo",
        title: "TaxDS",
        backgroundImage: productImages.taxongo.hero,
        infoSection: {
            image: productImages.taxongo.mockup,
            alt: "taxongoMockupImg",
            paragraphs: [
                <div className="col-12 text-primary">
                    <p>
                        Explore innovative cloud-based solutions designed to streamline tax
                        compliance processes. By automating compliance tasks, businesses
                        gain a significant edge in the competitive landscape of selling
                        within the U.S. market. With a robust network of over 100 signed
                        partner integrations, the technology seamlessly integrates with
                        existing systems, ensuring a smooth transition and maximum
                        efficiency.
                    </p>
                    <p>
                        The Cross-Border Solutions offered provide a comprehensive approach
                        to navigating international selling complexities. Whether small
                        businesses or large enterprises, the platform is tailored to meet
                        specific needs, providing tools and resources necessary for
                        compliance while expanding reach.
                    </p>
                    <p>
                        Prospective users are encouraged to click below to delve deeper into
                        the innovative solutions and discover how the tax compliance
                        automation platform can empower businesses. Experience the
                        convenience, efficiency, and reliability of the technology while
                        optimizing operations and focusing on driving growth in the global
                        marketplace. Join the journey to streamline tax obligations and
                        unlock new opportunities for success.
                    </p>
                </div>,
            ],
        },
    },
];

export const productUrlRouting = [
    {
        pathname: "/products/medrixo",
        pageName: "medrixo",
    },
    {
        pathname: "/products/tax_solutions",
        pageName: "taxongo",
    },
];
